export const TEXT = {
  common: {
    contactUs: 'Contact Us',
    aboutUs: 'About Us',
    ourStory: 'Our Story',
    privacyPolicy: 'Privacy Policy',
    refundPolicy: 'Refund Policy',
    termsAndConditions: 'Terms & Conditions',
    customerSupport: 'Customer Support',
    explore: 'Explore',
    premium: 'Premium',
    viewAll: 'View All',
    showAll: 'Show All',
    view: 'View',
    shopNow: 'Shop Now',
    comingSoon: 'Coming Soon',
    mmmk: 'MMMK WODE',
    buyNow: 'Buy Now',
    allProducts: 'All Products',
    enquiry: 'Enquiry',
    menu: 'Menu',
    signUp: 'Sign Up',
    signIn: 'Sign In',
    followUsOn: 'Follow Us On',
    footerDescription:
      'Discover MMMK WODE: where luxury meets versatility. From exquisite perfumes and fine jewelry to chic bikinis, fitness wear, handcrafted sandals, and elegant silk dresses, indulge in a world of refined style.',
    mmmkOfficialWebsite: 'MMMK WODE OFFICIAL WEBSITE',
    copyright: 'Copyright © 2026 MMMK WODE All Rights Reserved',
    productImageAlt: 'Product Image',
    collections: 'Collections',
    collection: 'Collection',
    bikini: 'Bikini',
    trendingSearches: 'Trending Searches',
    searchProductName1: 'MMMK UNISEX SET 1',
    searchProductDescription1:
      'Discover the MMMK WODE Unisex Perfume Set, featuring three distinctive fragrances crafted for versatile elegance. Each scent captures a unique blend of rich, woody notes, perfect for any occasion. Elevate your fragrance collection with this refined trio, designed to enhance your personal style and leave a lasting impression.',
    // searchProductName2: "MMMK UNISEX SET 1",
    // searchProductDescription2: "",
    // searchProductName3: "MMMK UNISEX SET 1",
    // searchProductDescription3: "",
    // searchProductName4: "MMMK UNISEX SET 1",
    // searchProductDescription4: "",
    home: 'Home',
    // sort: "Sort",
    // bestSellers: "Best Sellers",
    newsLetterHeading: 'EMAIL NEWSLETTER',
    newsLetterDescription:
      'Receive exclusive content and news from MMMK WODE and be the first to know about product launches and special announcements.',
    previous: 'Previous',
    next: 'Next',
    noResultsFound: 'More products coming soon',
    filters: 'Filters',
    addToCart: 'Add to Cart',
    rating: 'Rating',
    reviews: 'Reviews',
    submit: 'Submit',
    save: 'Save',
    add: 'Add',
    cancel: 'Cancel',
    delete: 'Delete',
    whatOurInfluencersSay: 'What Our Influencers Are Saying ?',
    subTotal: 'Subtotal',
    total: 'Total',
    apply: 'Apply',
    remove: 'Remove',
    // promoCode: "Promo Code",
    coupon: 'Coupon',
    checkout: 'Checkout',
    continueShopping: 'Continue Shopping',
    myOrders: 'My Orders',
    thankYou: 'THANK YOU',
    pleaseWait: 'Please Wait',
    loading: 'Loading...',
    close: 'Close',
    send: 'Send',
    email: 'Email',
    pageNotFound: 'Page Not Found',
    discount: 'Discount',
    gender: 'Gender',
    price: 'Price',
    processing: 'Processing',
    applying: 'Applying...',
    viewAvailableCoupons: 'View Available Coupons',
    tryAgain: 'Try Again',
    giftCard: 'Gift Card',
    by: 'by',
    on: 'on',
    giftCards: 'Gift Cards',
    signInToContinue: 'Please sign in to continue',
    addToWishlist: 'Add to wishlist',
    wishlistAdded: 'Added to wishlist successfully',
    wishlistAddFailed:
      'Failed to add to wishlist. Please refresh the page and try again.',
    loadingCategories: 'Loading categories...',
    outOfStock: 'Out of stock',
    itemUnavailable: 'Coming Soon',
    chooseOption: 'Please select a',
    selectedOptionNotFound: 'Selected option not found',
    addToCartFailed: 'Failed to add item to cart',
    fragrance: 'Fragrance',
    soldOut: 'Sold Out',
  },
  homepage: {
    section1Heading1: 'BE BLESSED & ENJOY ALL THE DESIGNS',
    section2Heading1: 'MMMK WODE COLLECTIONS',
    section4Heading1: 'EXCLUSIVE HANDMADE DRESSES',
    section4Heading2: 'ELEGANCE COMFORT STYLE',
    section4Heading3: 'EXCLUSIVE JEWELS Collection',
    section5Heading1: 'RECOMMENDED FOR YOU',
    section6Heading1: 'GRAND OPENING!',
    section6Description1: 'ALL ITEMS 19% OFF',
    section6Heading2: 'BY MMMK WODE',
    section7Heading1: 'SHOP INSTANT',
    section8Heading1:
      'Mel Money Room Spray captures the soul of the Caribbean, where sunlit shores meet timeless elegance. It opens with a zesty splash of grapefruit, bergamot, Sicilian mandarin, and juniper, echoing the freshness of ocean breezes and vibrant island fruits. The heart reveals a warm and spicy rhythm of pepper, rosemary, and Brazilian rosewood, reminiscent of tropical markets and the lush greenery of coastal hillsides. Finally, a deep, grounding base of musk, incense, and oakmoss evokes the mystery of twilight on the islands, where the air is rich, sensual, and endlessly inviting. Infused with the spirit of the Caribbean, Mel Money transforms any room into a haven of sunshine, spice, and sophistication — the perfect balance of island freedom and refined luxury.',
    section9ProductName1: 'M Queen',
    section9ProductName2: 'Mansa Musa Kanga Box',
    section9ProductName3: 'MO5',
    section9ProductName4: 'MO8',
    // section10Heading1: "Something Great is Coming",
    // section10Description1: "Stay tuned for our upcoming launch",
    section11Heading1: 'M Silky Musk',
    section11Description1:
      "Our new Sensational White Tahara M Silky Musk Intime is a unique and powerful perfume, originally intended for use in intimacy. It is a blend of rare and exotic aromas, designed to create an intimate atmosphere. A luxurious and exotic white musk is an incredibly versatile and unique fragrance , with its sensual scent and light texture, it has been used for centuries to create a range of perfumes. Despite this historical, secret and mysterious presence among oriental women, the application of Tahara intimate musk is actually very simple. is a natural aromatic fragrance derived from plants and flowers used for centuries in the Orient an ancestral self care for us as Queens . These ingredients are combined in such a way that they can help relax your mind while stimulating your body's natural arousal responses & will work miracles to stay feel confidence ,worthy light, comfortable all the day . Pretty secret for those looking to improve their personal hygiene routine.",
    section12Heading1: 'LUXURY RAW BLONDE PONYTAIL',
    section13Heading1: 'HAVE QUESTIONS ?',
    section14Heading1:
      'Our Caribbean Martinique Miss Univers love our Fragrance & Jewels',
    section16Heading1: 'Backstage Of The Brands',
    section17Heading1: 'Everyday Elegance: Wardrobe & Decor',
  },
  productDetails: {
    showAllIngredients: 'SHOW ALL INGREDIENTS',
    description: 'DESCRIPTION',
    directionsOfUse: 'DIRECTIONS OF USE',
    benefits: 'BENEFITS',
    brandDetails: 'BRAND DETAILS',
    addYourReview: 'Add Your Review',
    yourReview: 'Your Review',
    relatedProducts: 'RELATED PRODUCTS',
  },
  cart: {
    shoppingCart: 'Shopping Cart',
    paymentBreakdown: 'Payment Breakdown',
    enterPromoCode: 'Enter Promo Code',
    continueShopping: 'CONTINUE SHOPPING',
    addABag: 'Add a bag?',
    bagIncludes: 'Premium MMMK WODE gift bag & tissue paper',
    addBag: 'Add Bag',
    removeBag: 'Remove Bag',
    bagFeeLabel: 'Bag Fee',
    stockWarning: 'Only {qty} item(s) available for selected option',
  },
  thankYou: {
    orderReceived:
      'Your order has been received! Check My Orders for further updates. Happy Shopping.',
    orderUpdate: 'Order update',
    checkingOrder: 'Checking your order...',
    couldNotVerify: 'We could not verify this order yet.',
    refreshingPayment: 'Refreshing payment confirmation...',
    orderId: 'Order ID',
    status: 'Status',
    mode: 'Mode',
    payment: 'Payment',
    juraOrderId: 'Jura Order ID',
    total: 'Total',
    creditsUsed: 'Credits Used',
    amountDue: 'Amount Due',
    amountPaid: 'Amount Paid',
    amountToBePaid: 'Amount to be Paid',
  },
  checkout: {
    shippingCharges: 'Shipping Charges',
    tax: 'Tax',
    cashOnDeliveryShort: 'COD',
    extraCharges: 'Extra Charges',
    shippingAddress: 'Shipping Address',
    billingAddress: 'Billing Address',
    firstName: 'First Name',
    lastName: 'Last Name',
    streetAddress: 'Street Address',
    city: 'City',
    state: 'State',
    postalCode: 'Postal Code',
    country: 'Country',
    company: 'Company',
    landmark: 'Landmark',
    sameAsShippingAddress: 'Same as Shipping Address',
    phoneNumber: 'Phone Number',
    selectPaymentMethod: 'Select Payment Method',
    chooseHowToPay: 'Choose how to pay',
    payWithCard: 'Pay online',
    cardPaymentDescription: 'Visa, Mastercard, Amex, Apple pay etc',
    cashOnDelivery: 'Cash on Delivery',
    codPaymentDescription: 'Pay when your order is delivered',
    payWithTabby: 'Pay with Tabby',
    tabbyPaymentDescription: 'Pay in installments with Tabby',
    tabbySignInDescription: 'Sign in to use Tabby',
    redirectingToPaymentGateway: 'Redirecting to payment gateway...',
    checkoutFailed: 'Failed to checkout',
    saved: 'Saved',
    addresses: 'addresses',
    home: 'Home',
    default: 'Default',
    enterNewAddress: 'Enter a new address',
    billing: 'billing',
    billingSameAsShipping: 'Billing address same as shipping.',
    orderSummary: 'Order Summary',
    item: 'item',
    qty: 'Qty',
    appliedTo: 'Applied to',
    free: 'Free',
    deliveryDiscount: 'Delivery Discount',
    bagFee: 'Bag Fee',
    myCredit: 'My Credit',
    available: 'Available',
    orderPlacedSuccessfully: 'Order placed successfully',
    checkoutButton: 'CHECKOUT',
    noWalletCredit: 'No wallet credit available to apply',
    creditAppliedMsg: 'Applied {amount} from My Credit',
    creditRemovedMsg: 'Removed applied wallet credit',
    payLaterWithTabby: 'Pay later with Tabby',
    tabbyDescription: '4 interest-free payments',
    secureCheckout: 'Secure checkout',
    sslEncrypted: '256-bit SSL encrypted · your data is safe',
  },
  contact: {
    title: 'Contact Us',
    subtitle:
      'Tell us what you need and our team will get back to you as soon as possible.',
    name: 'Name',
    email: 'Email',
    phoneCountryCode: 'Country Code',
    phoneNumber: 'Phone Number',
    query: 'Query',
    namePlaceholder: 'Enter your name',
    emailPlaceholder: 'Enter your email',
    phoneNumberPlaceholder: 'Enter your phone number',
    queryPlaceholder: 'How can we help you?',
    countryCodePlaceholder: 'Select country code',
    submitSuccess: 'Your message has been sent successfully',
    submitError: 'Failed to send your message',
    requiredName: 'Name is required',
    requiredEmail: 'Email is required',
    requiredPhoneCode: 'Country code is required',
    requiredPhoneNumber: 'Phone number is required',
    requiredQuery: 'Query is required',
  },
  auth: {
    rememberMe: 'Remember Me',
    forgotPassword: 'Forgot Password ?',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    offer: 'MMMK WODE Newsletter - Receive 15% off your first purchase.',
  },
  forgotPasswordPage: {
    forgotPassword: 'Forgot Password',
    sendingMail: 'Sending Mail...',
    backtoAuth: 'Back to Sign In or Sign Up',
    newPassword: 'New Password',
    password: 'Password',
    confirmPassword: 'Confirm Password',
  },
  profile: {
    myAccount: 'My Account',
    myOrders: 'My Orders',
    savedItems: 'Saved Items',
    addressBook: 'Address Book',
    myCredit: 'My Credit',
    myPaymentMethods: 'My Payment Methods',
    signOut: 'Sign Out',
    personalInformation: 'Personal Information',
    firstName: 'First Name',
    lastName: 'Last Name',
    dateOfBirth: 'Date of Birth',
    contactNumber: 'Contact Number',
    selectGender: 'Select Gender',
    male: 'Male',
    female: 'Female',
    other: 'Other',
    email: 'Email',
    phone: 'Phone',
    company: 'Company',
    orderId: 'Order ID',
    date: 'Date',
    status: 'Status',
    paymentMethod: 'Payment Method',
    paymentMethods: 'Payment Methods',
    quantity: 'Quantity',
    action: 'Action',
    shippingInformation: 'Shipping Information',
    contactInformation: 'Contact Information',
    billingAddress: 'Billing Address',
    shippingAddress: 'Shipping Address',
    street: 'Street',
    city: 'City',
    state: 'State',
    postalCode: 'Postal Code',
    country: 'Country',
    support: 'Support',
    deliveryInformation: 'Delivery Information',
    deliveryStatus: 'Delivery Status',
    shipper: 'Shipper',
    awb: 'AWB',
    pending: 'Pending',
    trackPackage: 'Track Package',
    paymentBreakdown: 'Payment Breakdown',
    subTotal: 'Sub-Total',
    couponCodeApplied: 'Coupon Code Applied',
    totalPaidByCustomer: 'Total Paid by Customer',
    wishlist: 'Wishlist',
    relatedProducts: 'Related Products',
    brand: 'Brand',
    addGiftCard: 'Add Gift Card',
    enterGiftCardCode: 'Enter Gift Card Code',
    entergiftCardPass: 'Enter Gift Card Password',
    creditBalance: 'Credit Balance',
    creditBalanceDescription:
      'Your current credit balance can be used for future purchases.',
    savedCards: 'Saved Cards',
    addNewCard: 'Add New Card',
    cardType: 'Card Type',
    cardNumber: 'Card Number',
    expiryDate: 'Expiry Date',
    cardHolderName: 'Card Holder Name',
    enterCardNumber: 'Enter Card Number',
  },
  enquiryModal: {
    title: 'Write to us',
    name: 'Name',
    email: 'Email',
    contactNumber: 'Contact Number',
    subject: 'Subject',
    message: 'Message',
    nameRequired: 'Name is required',
    emailRequired: 'Email is required',
    subjectRequired: 'Subject is required',
    messageRequired: 'Message is required',
    namePlaceholder: 'Enter your name',
    emailPlaceholder: 'Enter your email',
    contactNumberPlaceholder: 'Enter your contact number',
    subjectPlaceholder: 'Enter your subject',
    messagePlaceholder: 'Enter your message',
    enquirySuccess: 'Thank you for your enquiry. We will get back to you soon.',
    enquiryError: 'Failed to submit enquiry',
  },
  giftCard: {
    myGiftCards: 'My Gift Cards',
    manageGiftCards: 'Manage your created gift cards',
    redeemGiftCard: 'Redeem Gift Card',
    buyGiftCard: 'Buy New Gift Card',
    totalCards: 'Total Gift Cards',
    active: 'Active',
    redeemed: 'Redeemed',
    totalValue: 'Total Value',
    errorLoading: 'Error loading gift cards',
    noGiftCards: 'No Gift Cards Yet',
    notCreated:
      "You haven't created any gift cards yet. Create your first one now!",
    buyFirstGiftCard: 'Buy Your First Gift Card',
    giftCardName: 'Gift Card Name',
    copyCode: 'Copy Code',
    copyPassword: 'Copy Password',
    password: 'Password',
    amount: 'Amount',
    redemptionInfo: 'Redemption Info',
    notRedeemed: 'Not Redeemed',
    createdAt: 'Created At',
    created: 'Created',
    expires: 'Expires',
  },
  buyGiftCard: {
    title: 'Gift Cards',
    subtitle: 'Give the perfect gift of choice',
    mmmkWoodGiftCard: 'MMMK WODE Gift Card',
    giftCardDescription: 'Perfect for any occasion',
    giftCardName: 'Gift Card Name',
    validForOnlinePurchases: 'Valid for online purchases',
    termsApply: 'Terms Apply',
    whyChoose: 'Why Choose Our Gift Cards?',
    validForAYear: 'Valid for a year of purchase',
    anyProduct: 'Can be used to purchase any product',
    instantRedemption: 'Instant Redemption',
    purchaseGiftCard: 'Purchase Gift Card',
    processing: 'Processing',
    pleaseEnterGiftCardName: 'Please enter gift card name',
    atLeast2Char: 'Name must be at least 2 characters',
    atMost50Char: 'Name cannot exceed 50 characters',
    namePlaceholder: 'e.g., Birthday Gift, Holiday Card, Thank You',
    selectAmount: 'Select Amount',
    customAmount: 'Or enter custom amount',
    pleaseEnterGiftCardAmount: 'Please enter gift card amount',
    enterAmount: 'Enter Amount',
    purchaseSummary: 'Purchase Summary',
    giftCardAmount: 'Gift Card Amount',
    term1: 'Gift cards can be bought and redeemed instantly',
    term2: 'Can be used for online and in-store purchases',
    term3: 'Cannot be redeemed for cash',
    term4: 'Terms and conditions apply',
  },
  legal: {
    privacyPolicy: 'Privacy Policy',
    returnPolicy: 'Return & Refund Policy',
    termsConditions: 'Terms & Conditions',
  },
};
